// Domain constants & label maps (German UI)

export const PIPELINE_COLUMNS = [
  { key: "idea", label: "Idee", statuses: ["idea"], drop: "idea" },
  { key: "in_progress", label: "In Arbeit", statuses: ["draft", "creator_working", "review"], drop: "creator_working" },
  { key: "approved", label: "Freigegeben", statuses: ["approved", "scheduled", "publishing", "schedule_failed"], drop: "approved" },
  { key: "published", label: "Veröffentlicht", statuses: ["published"], drop: "published" },
];

export const columnOfStatus = (status) =>
  PIPELINE_COLUMNS.find((c) => c.statuses.includes(status)) || PIPELINE_COLUMNS[0];

export const STATUS_LABEL = {
  idea: "Idee",
  research: "Idee",
  draft: "In Arbeit",
  creator_working: "In Arbeit",
  review: "Wartet auf Freigabe",
  approved: "Freigegeben",
  scheduled: "Geplant",
  publishing: "Wird veröffentlicht",
  schedule_failed: "Planung fehlgeschlagen",
  published: "Veröffentlicht",
};

export const STATUS_STYLE = {
  idea: "bg-neutral-100 text-neutral-600 border-neutral-200",
  research: "bg-neutral-100 text-neutral-600 border-neutral-200",
  draft: "bg-indigo-50 text-indigo-700 border-indigo-200",
  creator_working: "bg-indigo-50 text-indigo-700 border-indigo-200",
  review: "bg-amber-100 text-amber-800 border-amber-200",
  approved: "bg-green-100 text-green-800 border-green-200",
  scheduled: "bg-teal-50 text-teal-700 border-teal-200",
  publishing: "bg-teal-100 text-teal-800 border-teal-300",
  schedule_failed: "bg-rose-50 text-rose-700 border-rose-200",
  published: "bg-neutral-900 text-white border-neutral-900",
};

export const FLAG_META = {
  hot: { label: "Heißes Thema", className: "bg-red-100 text-red-700 border-red-200", dot: "#DC2626" },
  event: { label: "Eventrelevant", className: "bg-amber-100 text-amber-800 border-amber-200", dot: "#F59E0B" },
  high_reach: { label: "Hoher Reichweitenhebel", className: "bg-blue-100 text-blue-700 border-blue-200", dot: "#2563EB" },
  sensitive: { label: "Sensibel", className: "bg-rose-50 text-rose-700 border-rose-200", dot: "#E11D48" },
};

export const HEAT_META = {
  hot: { label: "Heiß", className: "bg-red-100 text-red-700 border-red-200" },
  warm: { label: "Warm", className: "bg-amber-100 text-amber-800 border-amber-200" },
  cold: { label: "Kalt", className: "bg-neutral-100 text-neutral-600 border-neutral-200" },
};

export const PRIORITY_META = {
  high: { label: "Hoch", className: "bg-red-50 text-red-700 border-red-200" },
  medium: { label: "Mittel", className: "bg-amber-50 text-amber-700 border-amber-200" },
  low: { label: "Niedrig", className: "bg-neutral-100 text-neutral-500 border-neutral-200" },
};

export const TYPE_LABEL = { reel: "Reel", story: "Story", post: "Post", carousel: "Karussell" };
